import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  private userLoggedIn = new Subject<boolean>();

  constructor(private http: HttpClient) {
    this.userLoggedIn.next(false);
  }

  public setUserLoggedIn(userLoggedIn: boolean) {
    this.userLoggedIn.next(userLoggedIn);
  }

  public getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();
  }

  public get(url: string) {
    return this.http.get(url);
  }

  public setIpLocalStorage(url: any) {
    this.http.get(url).subscribe((data: any) => {
      localStorage.setItem('ip_address', data.ip);
    });
  }

  public getIp() {
    return this.http.get('https://api.ipify.org/?format=json');
  }

  public post(url: string, formData: FormData): Observable<any> {
    return this.http.post<any>(url, formData);
  }
}
